package com.trevorwiebe.timesheet.core.presentation

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.BottomAppBar
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.FloatingActionButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.ChipItem
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.TimeSheetStatus
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.color
import org.jetbrains.compose.resources.painterResource
import timesheet.composeapp.generated.resources.Res
import timesheet.composeapp.generated.resources.round_check_24

@Composable
actual fun ShiftBottomBar(
    onConfirmPayPeriod: () -> Unit,
    status: List<TimeSheetStatus>,
) {
    BottomAppBar(
        containerColor = MaterialTheme.colorScheme.surface,
        contentColor = MaterialTheme.colorScheme.tertiary,
        modifier = Modifier.fillMaxWidth(),
        actions = {
            status.forEach {
                ChipItem(text = it.title, color = it.color)
            }
        },
        floatingActionButton = {
            FloatingActionButton(
                onClick = { if (status.contains(TimeSheetStatus.CONFIRM_HOURS_NOW)) onConfirmPayPeriod() },
                containerColor = if (status.contains(TimeSheetStatus.CONFIRM_HOURS_NOW)) MaterialTheme.colorScheme.tertiary
                else MaterialTheme.colorScheme.tertiaryContainer,
                contentColor = if (status.contains(TimeSheetStatus.CONFIRM_HOURS_NOW)) MaterialTheme.colorScheme.onTertiary
                else MaterialTheme.colorScheme.onTertiaryContainer,
                elevation = FloatingActionButtonDefaults.bottomAppBarFabElevation(),
            ) {
                Icon(
                    painter = painterResource(Res.drawable.round_check_24),
                    contentDescription = "Localized description"
                )
            }
        }
    )
}
